<ng-container *ngrxLet="vm$ as vm">
    @if (vm) {
        @if (desktop) {
            <div class="targeted-promotions-layout row">
                <div class="col12 col-md-8">
                    @if (vm?.overviewContent; as overviewContent) {
                        <div class="overview overview-description">
                            <div class="overview-description-content">
                                @if (overviewContent?.promoTeaserInfo) {
                                    <div class="overview-description-top">
                                        {{ overviewContent?.promoTeaserInfo }}
                                    </div>
                                }
                                @if (overviewContent?.winUpto) {
                                    <div class="overview-description-t1">
                                        {{ overviewContent?.winUpto }}
                                    </div>
                                }
                                @if (overviewContent?.prizeMessage) {
                                    <div class="overview-description-title">
                                        {{ overviewContent?.prizeMessage }}
                                    </div>
                                }
                                @if (overviewContent?.additionalMessage) {
                                    <div class="overview-description-desc">
                                        {{ overviewContent?.additionalMessage }}
                                    </div>
                                }
                                @if (overviewContent?.additionalText) {
                                    <div
                                        [ngClass]="
                                            overviewContent?.additionalTextFontSize?.toLowerCase() === 'large'
                                                ? 'overview-description-desc'
                                                : 'overview-description-extra-desc'
                                        ">
                                        {{ overviewContent?.additionalText }}
                                    </div>
                                }
                            </div>
                            <div class="overview-description-image">
                                <img
                                    class="overview-img"
                                    [attr.src]="overviewContent?.image?.src"
                                    [attr.alt]="overviewContent?.image?.alt"
                                    [attr.height]="overviewContent?.image?.height"
                                    [attr.width]="overviewContent?.image?.width" />
                            </div>
                        </div>
                    }
                    <base-details-terms-conditions
                        [detailsContent]="vm?.baseDetailsContent"
                        [viewType]="viewType"
                        [clientContent]="vm?.clientContentMessages">
                    </base-details-terms-conditions>
                </div>
                <div class="col12 col-md-4">
                    <tp-opt-in></tp-opt-in>
                    @if (vm?.displayPlayNow) {
                        <ng-content select="[playNow]"></ng-content>
                    }
                    <ng-content select="[criteria]"></ng-content>
                    <tp-rewards [rewardContent$]="rewardsContent$"></tp-rewards>
                    <multi-rewards-list></multi-rewards-list>
                    <ng-container *ngTemplateOutlet="secondaryRewardsTpl"></ng-container>
                </div>
            </div>
        }
        @if (!desktop) {
            <div class="targeted-promotions-layout">
                <div class="col">
                    @if (vm?.overviewContent; as overviewContent) {
                        <div class="overview overview-description">
                            @if (overviewContent?.promoTeaserInfo) {
                                <div class="overview-description-top">
                                    {{ overviewContent?.promoTeaserInfo }}
                                </div>
                            }
                            @if (overviewContent?.winUpto) {
                                <div class="overview-description-t1">
                                    {{ overviewContent?.winUpto }}
                                </div>
                            }
                            @if (overviewContent?.prizeMessage) {
                                <div class="overview-description-title">
                                    {{ overviewContent?.prizeMessage }}
                                </div>
                            }
                            <div class="overview-description-image">
                                <img
                                    class="overview-img"
                                    [attr.src]="overviewContent?.image?.src"
                                    [attr.alt]="overviewContent?.image?.alt"
                                    [attr.height]="overviewContent?.image?.height"
                                    [attr.width]="overviewContent?.image?.width" />
                            </div>
                            @if (overviewContent?.additionalMessage) {
                                <div class="overview-description-desc">
                                    {{ overviewContent?.additionalMessage }}
                                </div>
                            }
                            @if (overviewContent?.additionalText) {
                                <div
                                    [ngClass]="
                                        overviewContent?.additionalTextFontSize?.toLowerCase() === 'large'
                                            ? 'overview-description-desc'
                                            : 'overview-description-extra-desc'
                                    ">
                                    {{ overviewContent?.additionalText }}
                                </div>
                            }
                        </div>
                    }
                    <tp-rewards [rewardContent$]="rewardsContent$"></tp-rewards>
                    <multi-rewards-list></multi-rewards-list>
                    <ng-container *ngTemplateOutlet="secondaryRewardsTpl"></ng-container>
                    <base-details-terms-conditions
                        class="w-100"
                        [detailsContent]="vm?.baseDetailsContent"
                        [viewType]="viewType"
                        [clientContent]="vm?.clientContentMessages">
                    </base-details-terms-conditions>
                    <tp-opt-in></tp-opt-in>
                </div>
            </div>
        }
    }
</ng-container>
